import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class PromissoryNotesPolicy extends BasePolicy {
  static canView() {
    const roles = [
      Roles.CREDIT_COLLECTIONS,
      Roles.CREDIT_ASSISTANT,
      Roles.SUPER_USER,
    ];
    const channels = [Channels.WHOLESALER, Channels.RETAIL];
    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}
